export const initialCardParams = {
  Type: "minion",
  Class: "Neutral",
  DualClass: "",
  Banner: "",
  RightBanner: "",
  Rarity: "Common",
  Title: "",
  Tribe: "",
  Cost: { Type: "Mana", Value: "" },
  TrinketUD: "",
  ChronumCost: "",
  Attack: "",
  Health: "",
  Runes: { Slot1: "", Slot2: "", Slot3: "" },
  Text: "",
  Emblem: "JAILIcon",
  Art: { Type: 0, File: "", Width: "", Height: "", X: "", Y: "" },
  Overwrite: { FontSize: 0, Dragon: false, Emblem: true }
};

export const CLASSES = [
  "Neutral", "DeathKnight", "DemonHunter", "Druid", "Hunter", 
  "Mage", "Paladin", "Priest", "Rogue", "Shaman", "Warlock", "Warrior"
];

export const RARITIES = ["Free", "Common", "Rare", "Epic", "Legendary"];

export const STANDARD_TRIBES = [
  "Beast", "Demon", "Dragon", "Elemental", "Mech", "Murloc", 
  "Naga", "Pirate", "Quilboar", "Totem", "Undead", "All"
];

export const MAIN_TYPES = [
  { id: 'minion', label: 'Minion', icon: 'icon-minion.webp' },
  { id: 'spell', label: 'Spell', icon: 'icon-spell.webp' },
  { id: 'weapon', label: 'Weapon', icon: 'icon-weapon.webp' },
  { id: 'heropower', label: 'Power', icon: 'heropower-icon.webp' },
  { id: 'hero', label: 'Portrait', icon: 'portrait-test.webp' },
  { id: 'herocard', label: 'Hero', icon: 'hero-icon (1).webp' },
  { id: 'location', label: 'Location', icon: 'location-icon.webp' }
];

export const SUB_TYPES = {
  'minion': [{ id: 'minion', label: 'Regular' }, { id: 'minion_golden', label: 'Golden' }, { id: 'minion_diamond', label: 'Diamond' }, { id: 'signature26', label: 'Signature' }, { id: 'signature25', label: 'Signature GS' }],
  'spell': [{ id: 'spell', label: 'Regular' }, { id: 'spell_golden', label: 'Golden' }, { id: 'anomaly', label: 'Anomaly' }, { id: 'bgspell', label: 'BG Spell' }],
  'weapon': [{ id: 'weapon', label: 'Regular' }, { id: 'weapon_golden', label: 'Golden' }, { id: 'weapon_signature', label: 'Signature' }],
  'heropower': [{ id: 'heropower', label: 'Regular' }, { id: 'trinket', label: 'Trinket' }],
  'hero': [{ id: 'hero', label: 'Regular' }],
  'herocard': [{ id: 'herocard', label: 'Regular' }, { id: 'herocard_golden', label: 'Golden' }, { id: 'bosscard', label: 'Boss Card' }],
  'location': [{ id: 'location', label: 'Regular' }, { id: 'location_golden', label: 'Golden' }]
};

// Mapping standard tribes and spell schools to their image paths
export const TRIBE_ICONS = {
  // Minion Tribes
  'All': '/images/tribes/all.webp',
  'Beast': '/images/tribes/beast.webp',
  'Demon': '/images/tribes/demon.webp',
  'Draenei': '/images/tribes/draenei.webp',
  'Dragon': '/images/tribes/dragon.webp',
  'Elemental': '/images/tribes/elemental.webp',
  'Mech': '/images/tribes/mech.webp',
  'Murloc': '/images/tribes/murloc.webp',
  'Naga': '/images/tribes/naga.webp',
  'Pirate': '/images/tribes/pirate.webp',
  'Quilboar': '/images/tribes/quilboar.webp',
  'Totem': '/images/tribes/totem2.webp',
  'Undead': '/images/tribes/undead.webp',
  
  // Spell Schools
  'Arcane': '/images/schools/arcane.webp',
  'Fire': '/images/schools/fire.webp',
  'Frost': '/images/schools/frost.webp',
  'Nature': '/images/schools/nature.webp',
  'Holy': '/images/schools/holy.webp',
  'Shadow': '/images/schools/shadow.webp',
  'Fel': '/images/schools/fel.webp'
};

export const EMBLEMS = [
  {
    label: "Recent",
    options: [
      { id: "ROTBEIcon", label: "ROTBE" },
      { id: "JAILIcon_MiniSet", label: "Violet Hold Mini Set" },
      { id: "JAILIcon", label: "Escape from Violet Hold" },
      { id: "CATAIcon_MiniSet", label: "Restoration of Azeroth" },
      { id: "CATAIcon", label: "Cataclysm" },
      { id: "CoreIcon_Even3", label: "Year of the Scarab" }
    ]
  },
  {
    label: "Standard",
    options: [
      { id: "ROTBEIcon", label: "ROTBE" },
      { id: "JAILIcon_MiniSet", label: "Violet Hold Mini Set" },
      { id: "JAILIcon", label: "Escape from Violet Hold" },
      { id: "CATAIcon_MiniSet", label: "Restoration of Azeroth" },
      { id: "CATAIcon", label: "Cataclysm" },
      { id: "ATTIcon_MiniSet", label: "Echoes of the Infinite" },
      { id: "ATTIcon", label: "Across the Timeways" },
      { id: "TLCIcon_Miniset", label: "Day of Rebirth" },
      { id: "TLCIcon", label: "Lost City of Un'Goro" },
      { id: "EDRIcon", label: "Emerald Dream" },
      { id: "EDRIcon_Miniset", label: "Emerald Dream MS" },
      { id: "GDBIcon_MiniSetSC", label: "Heroes of StarCraft" },
      { id: "GDBIcon", label: "Great Dark Beyond" },
      { id: "PRIcon_MiniSet", label: "The Traveling Travel Agency" },
      { id: "PRIcon", label: "Perils in Paradise" },
      { id: "TOYIcon_MiniSet", label: "Dr. Boom’s Incredible Inventions" },
      { id: "TOYIcon", label: "Whizbang's Workshop" }
    ]
  },
  {
    label: "Wild",
    options: [
      { id: "WWIcon_MiniSet", label: "Delve into Deepholm" },
      { id: "WWIcon", label: "Showdown in the Badlands" },
      { id: "TTNIcon_MiniSet", label: "Fall of Ulduar" },
      { id: "TTNIcon", label: "TITANS" },
      { id: "BotBIcon_MiniSet", label: "Audiopocalypse" },
      { id: "BotBIcon", label: "Festival of Legends" },
      { id: "RLKIcon_MiniSet", label: "Return to Naxxramas" },
      { id: "RLKIcon", label: "Lich King" },
      { id: "REV_Icon_MiniSet", label: "Maw and Disorder" },
      { id: "REV_Icon", label: "Castle Nathria" },
      { id: "SCIcon_MiniSet", label: "Throne of the Tides" },
      { id: "SCIcon", label: "Sunken City" },
      { id: "AVIcon_MiniSet", label: "Onyxia's Lair" },
      { id: "AVIcon", label: "Alterac Valley" },
      { id: "SWIcon_MiniSet", label: "Deadmines" },
      { id: "SWIcon", label: "Stormwind" },
      { id: "BARIcon_MiniSet", label: "Wailing Caverns" },
      { id: "BARIcon", label: "Barrens" },
      { id: "DMFIcon_MiniSet", label: "Darkmoon Races" },
      { id: "DMFIcon", label: "Darkmoon" },
      { id: "SCHIcon", label: "Scholomance" },
      { id: "DHIIcon", label: "Initiate" },
      { id: "BTIcon", label: "Outland" },
      { id: "DRGIcon_MiniSet", label: "Dragons" },
      { id: "DRGIcon", label: "Dragons" },
      { id: "UldumIcon", label: "Uldum" },
      { id: "DALIcon", label: "Rise of Shadows" },
      { id: "TRLIcon", label: "Rumble" },
      { id: "BOTIcon", label: "Boomsday" },
      { id: "GILIcon", label: "Witchwood" },
      { id: "LOOTIcon", label: "Kobolds" },
      { id: "ICCIcon", label: "Frozen Throne" },
      { id: "UNGIcon", label: "Un'Goro" },
      { id: "GangsIcon", label: "Gadgetzan" },
      { id: "KaraIcon", label: "Karazhan" },
      { id: "OGIcon", label: "Old Gods" },
      { id: "LOEIcon", label: "League of Explorers" },
      { id: "TGTIcon", label: "Grand Tournament" },
      { id: "BRMIcon", label: "Blackrock Mountain" },
      { id: "GvGIcon", label: "Goblins vs Gnomes" },
      { id: "NaxxIcon", label: "Naxxramas" },
      { id: "GenFX_Set1_Icon", label: "Classic" }
    ]
  },
  {
    label: "Extra",
    options: [
      { id: "EVENTEvergreenIcon", label: "Event Evergreen" },
      { id: "CoreIcon_Even3", label: "Year of the Scarab" },
      { id: "59263529", label: "Year of the Raptor" },
      { id: "GDBIcon_MiniSet", label: "GDB Miniset (Unused)" },
      { id: "EventIcon", label: "Event" },
      { id: "26794860", label: "Year of the Pegasus" },
      { id: "COTIcon", label: "Caverns of Time" },
      { id: "5eb42d9d", label: "Year of the Wolf" },
      { id: "TwistIcon", label: "Twist" },
      { id: "POAIcon", label: "Path of Arthas" },
      { id: "Legacy", label: "Legacy" },
      { id: "Classic", label: "Hall of Fame" },
      { id: "CORE", label: "Year of Hydra" },
      { id: "PLACEHOLDER_202204", label: "Year of Gryphon" }
    ]
  }
];